import PropTypes from "prop-types";
import { lazy, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Loader from "components/Loader";
import Loadable from "components/Loadable";
import useAuth from "hooks/useAuth";
import { canAccessAdminPanel } from "utils/adminAccess";

const MaintenanceError = Loadable(
  lazy(() => import("pages/maintenance/error/404")),
);

export default function AdminGuard({ children }) {
  // const { user: userData, userLoading } = useGetUser();
  const [is_admin, setIsAdmin] = useState(false);
  const { user, isLoggedIn, isInitialized } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  
  
  useEffect(() => {
    if (isInitialized) {
      if (isLoggedIn) {
        if (user) {
          setIsAdmin(canAccessAdminPanel(user));
        }
      } else if (!isLoggedIn) {
        // Non-logged in user trying to access protected pages
        navigate("/login", {
          state: { from: location.pathname },
          replace: true,
        });
      }
    }
  }, [user, isLoggedIn, isInitialized, navigate, location.pathname]);

  if (!isInitialized) {
    return <Loader />;
  }
  if (is_admin) {
    return children
  }
  return <MaintenanceError />
}

AdminGuard.propTypes = {
  children: PropTypes.node,
};
